/**
 * Supabase auth user_metadata keys and helpers for signup/OAuth.
 * DB triggers expect `portal_role` on new users so profiles.role is set.
 */

export type PortalRole = 'creator' | 'org';

/** Set before OAuth redirect; read on /auth/callback to merge into user_metadata. */
export const PENDING_PORTAL_ROLE_STORAGE_KEY = 'portal_pending_portal_role_for_oauth';
